import React from 'react';

const SkipListSection = ({ clinic, editedClinic, setEditedClinic, isEditing }) => {
  const settings = isEditing ? editedClinic?.settings : clinic?.settings;
  const skipList = settings?.skip_list;
  const numbers = Array.isArray(skipList?.numbers) ? skipList.numbers : [];

  console.log('SkipListSection - isEditing:', isEditing);
  console.log('SkipListSection - skipList:', skipList);

  const handleNumbersChange = (value) => {
    if (!isEditing) return;
    setEditedClinic(prev => ({
      ...prev,
      settings: {
        ...prev.settings || {},
        skip_list: {
          ...prev.settings?.skip_list || {},
          numbers: value
        }
      }
    }));
  };

  const addNumber = () => {
    handleNumbersChange([...numbers, '']);
  };

  const updateNumber = (index, value) => {
    const next = [...numbers];
    next[index] = value;
    handleNumbersChange(next);
  };

  const removeNumber = (index) => {
    const next = [...numbers];
    next.splice(index, 1);
    handleNumbersChange(next);
  };

  if (!isEditing) {
    return (
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-md font-semibold mb-4">Skip List</h4>
        <p className="text-sm text-gray-500 mb-3">
          WhatsApp numbers on this list never receive AI auto-replies. Messages are still
          stored and staff can reply manually.
        </p>
        {numbers.filter(Boolean).length ? (
          <ul className="list-disc list-inside space-y-1">
            {numbers.filter(Boolean).map((number, index) => (
              <li key={index} className="text-sm text-gray-900">{number}</li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-500">No numbers on skip list.</p>
        )}
      </div>
    );
  }

  return (
    <div className="mt-6 pt-6 border-t border-gray-200">
      <h4 className="text-md font-semibold mb-4">Skip List</h4>
      <p className="text-sm text-gray-500 mb-4">
        WhatsApp numbers on this list never receive AI auto-replies (denylist). This is the
        inverse of test mode authorized numbers. Matching ignores &apos;+&apos;, spaces and dashes.
      </p>

      <div className="space-y-3">
        <label className="block text-sm font-medium text-gray-700">
          Skip-listed WhatsApp Numbers
        </label>
        <div className="space-y-2 max-h-60 overflow-y-auto">
          {numbers.map((number, index) => (
            <div key={index} className="flex items-center space-x-2">
              <input
                type="text"
                value={number || ''}
                onChange={(e) => updateNumber(index, e.target.value)}
                className="flex-1 p-2 border rounded"
                placeholder="+85291234567"
              />
              <button
                type="button"
                onClick={() => removeNumber(index)}
                className="px-3 py-2 text-sm text-red-600 border border-red-200 rounded hover:bg-red-50"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={addNumber}
          className="px-3 py-2 text-sm text-blue-600 border border-blue-200 rounded hover:bg-blue-50"
        >
          + Add Number
        </button>
      </div>
    </div>
  );
};

export default SkipListSection;
